import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { z } from 'zod';

export const CreateProductClaimSchema = z.object({
  product_id: z.string().min(1, {
    message: 'Produk tidak boleh kosong!',
  }),
  code: z.string().min(1, {
    message: 'Kode tidak boleh kosong!',
  }),
  name: z.string().min(1, {
    message: 'Judul tidak boleh kosong!',
  }),
  max_quota: z.number({ message: 'Kuota harus berupa angka!' }),
  allow_mode: z.enum(['ALL', 'WHITELIST'], {
    message: 'Mode tidak valid!',
  }),
  allow_type: z.enum(['EMAIL']).optional(),
  allow_lists: z.array(z.string().email()).optional(),
  is_active: z.boolean(),
  starts_at: z.string().min(1, {
    message: 'Tanggal mulai tidak boleh kosong!',
  }),
  expired_at: z.string().min(1, {
    message: 'Tanggal kadaluarsa tidak boleh kosong!',
  }),
});
export type CreateProductClaimPayload = z.infer<
  typeof CreateProductClaimSchema
>;
export type CreateProductClaimResponse = ApiResponse<{
  name: string;
}>;

export const createProductClaim = async (
  payload: CreateProductClaimPayload
): Promise<CreateProductClaimResponse> => {
  const url = 'product-promotion';

  return await apiClient.post(url, payload);
};

export function createProductClaimMutationOptions() {
  return mutationOptions<
    CreateProductClaimResponse,
    AxiosError,
    CreateProductClaimPayload
  >({
    mutationFn: createProductClaim,
  });
}
